const routers = [
    {
        path: '/personal_center',
        name: 'personal_center',
        meta: {
            exp: '个人中心',
            requireAuth: true
        },
        redirect: '/personal_center/homepage',
        component: () => import('@/views/peronsal_center/index.vue'),
        children: [
            {
                path: '/personal_center/homepage',
                name: 'personal_center_homepage',
                meta: {
                    exp: '个人主页',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/homepage/index.vue'),
                children: [
                    {
                        path: '/personal_center/swiper_manage',
                        name: 'personal_center_swiper_manage',
                        meta: {
                            exp: '小程序轮播图',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/swiper_manage/index.vue'),
                    },
                    {
                        path: '/personal_center/competition_management',
                        name: 'personal_center_competition_management',
                        meta: {
                            exp: '比赛管理-列表',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/competition_management/index.vue'),
                    },
                    {
                        path: '/personal_center/competition_management/add_competition',
                        name: 'personal_center_competition_management_add_competition',
                        meta: {
                            exp: '比赛管理-添加比赛',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/competition_management/add_competition/index.vue'),
                    },
                    {
                        path: '/personal_center/competition_management/competition_detail',
                        name: 'personal_center_competition_management_competition_detail',
                        meta: {
                            exp: '比赛管理-比赛详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/competition_management/competition_detail/index.vue'),
                    },
                    {
                        path: '/personal_center/competition_management/Judge_management',
                        name: 'personal_center_competition_management_Judge_management',
                        meta: {
                            exp: '比赛管理-评委管理',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/competition_management/Judge_management/index.vue'),
                    },
                    {
                        path: '/personal_center/competition_management/scoring_criteria',
                        name: 'personal_center_competition_management_scoring_criteria',
                        meta: {
                            exp: '比赛管理-评分标准',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/competition_management/scoring_criteria/index.vue'),
                    },
                    {
                        path: '/personal_center/competition_management/pro_management',
                        name: 'personal_center_competition_management_pro_management',
                        meta: {
                            exp: '比赛管理-作品管理',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/competition_management/pro_management/index.vue'),
                    },
                    {
                        path: '/personal_center/GEmanage',
                        name: 'personal_center_GEmanage',
                        meta: {
                            exp: '展会管理',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/GEmanage/index.vue'),
                    },
                    {
                        path: '/personal_center/addGE',
                        name: 'personal_center_addGE',
                        meta: {
                            exp: '展会管理-新增展会',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/GEmanage/addGE/index.vue'),
                    },
                    {
                        path: '/personal_center/GEdetail',
                        name: 'personal_center_GEdetail',
                        meta: {
                            exp: '展会管理-展会详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/GEmanage/GE_detail.vue'),
                    },
                    {
                        path: '/personal_center/mange_work',
                        name: 'personal_center_mange_work',
                        meta: {
                            exp: '展会管理-管理作品',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/mange_work/index.vue'),
                    },
                    {
                        path: '/personal_center/mange_work_detail',
                        name: 'personal_center_mange_work_detail',
                        meta: {
                            exp: '展会管理-作品详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/mange_work/work_detail.vue'),
                    },
                    {
                        path: '/personal_center/teacher_mangaer',
                        name: 'personal_center_teacher_mangaer',
                        meta: {
                            exp: '教师管理',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/school/teacher_manage/index.vue'),
                    },
                    {
                        path: '/personal_center/student_mangaer',
                        name: 'personal_center_student_mangaer',
                        meta: {
                            exp: '学生管理',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/teacher/student_manage/index.vue'),
                    },
                    {
                        path: '/personal_center/finaly_design_manage',
                        name: 'personal_center_finaly_design_manage',
                        meta: {
                            exp: '毕设管理',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/teacher/finaly_design_manage/index.vue'),
                    },
                    {
                        path: '/personal_center/finaly_design_list',
                        name: 'personal_center_finaly_design_list',
                        meta: {
                            exp: '我的毕设列表',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/student/finaly_design_list.vue'),
                    },
                    {
                        path: '/personal_center/works',
                        name: 'personal_center_works',
                        meta: {
                            exp: '我的作品',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/works/index.vue'),
                    },
                    {
                        path: '/homepage_dynamic',
                        name: 'homepage_dynamic',
                        meta: {
                            exp: '个人主页-动态',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/dynamic/index.vue'),
                    },
                  
                    {
                        path: '/homepage_collection',
                        name: 'homepage_collection',
                        meta: {
                            exp: '个人主页-收藏',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/collection/index.vue'),
                    },
                    {
                        path: '/homepage_fans',
                        name: 'homepage_fans',
                        meta: {
                            exp: '个人主页-粉丝',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/homepage/fans/index.vue'),
                    }
                ]
            },
            {
                path: '/personal_center/teacher_mangaer_detail',
                name: 'personal_center_teacher_mangaer_detail',
                meta: {
                    exp: '教师管理详情',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/homepage/school/teacher_manage/teacher_detail.vue'),
            },
            {
                path: '/personal_center/student_mangaer_detail',
                name: 'personal_center_student_mangaer_detail',
                meta: {
                    exp: '学生管理详情',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/homepage/teacher/student_manage/student_detail.vue'),
            },
            {
                path: '/personal_center/manage_finaly_design_detail',
                name: 'personal_center_manage_finaly_design_detail',
                meta: {
                    exp: '审核毕设作品详情',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/homepage/teacher/finaly_design_manage/finaly_design_detail.vue'),
            },
            {
                path: '/personal_center/i_am_judge',
                name: 'personal_center_i_am_judge',
                meta: {
                    exp: '个人主页-我是评委',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/homepage/school/competition_management/i_am_judge/index.vue'),
            },
            {
                path: '/personal_center/judge/review_list',
                name: 'personal_center_judge_review_list',
                meta: {
                    exp: '个人主页-我是评委-评审作品列表',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/homepage/school/competition_management/i_am_judge/review_list/index.vue'),
            },
            {
                path: '/personal_center/judge/scoring',
                name: 'personal_center_judge_scoring',
                meta: {
                    exp: '个人主页-我是评委-作品评分',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/homepage/school/competition_management/i_am_judge/scoring/index.vue'),
            },
            {
                path: '/personal_center/homepage_care',
                name: 'homepage_care',
                meta: {
                    exp: '个人主页-关注的人',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/care/index.vue'),
            },
            {
                path: '/personal_center/homepage_like',
                name: 'homepage_like',
                meta: {
                    exp: '个人主页-赞过',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/like/index.vue'),
            },
            {
                path: '/personal_center/task',
                name: 'personal_center_task',
                meta: {
                    exp: '我的任务',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/task/index.vue'),
            },
            
            {
                path: '/personal_center/course',
                name: 'personal_center_course',
                meta: {
                    exp: '我的课程',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/course/index.vue'),
            },
            {
                path: '/personal_center/experience',
                name: 'personal_center_experience',
                meta: {
                    exp: '我的经验值',
                    requireAuth: true
                },
                redirect: '/personal_center/experience_home',
                component: () => import('@/views/peronsal_center/experience/index.vue'),
                children: [
                    {
                        path: '/personal_center/experience_home',
                        name: 'personal_center_experience_home',
                        meta: {
                            exp: '我的经验值',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/experience/experience_home/index.vue'),
                    },
                    {
                        path: '/personal_center/add_education',
                        name: 'personal_center_add_education',
                        meta: {
                            exp: '我的经验值_添加教育经历',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/experience/add_education/index.vue'),
                    },
                    {
                        path: '/personal_center/add_praise',
                        name: 'personal_center_add_praise',
                        meta: {
                            exp: '我的经验值_添加获奖经历',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/experience/add_praise/index.vue'),
                    }
                ]
            },
            {
                path: '/personal_center/account',
                name: 'personal_center_account',
                meta: {
                    exp: '账号信息',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/account/index.vue'),
            },
            {
                path: '/personal_center/safe',
                name: 'personal_center_safe',
                meta: {
                    exp: '账号安全',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/safe/index.vue'),
                redirect: '/personal_center/safe/account_safe',
                children: [
                    {
                        path: '/personal_center/safe/account_safe',
                        name: 'personal_center_account_safe',
                        meta: {
                            exp: '账号安全',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/account_safe/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/change_password',
                        name: 'personal_center_change_password',
                        meta: {
                            exp: '账号安全-修改密码',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/change_password/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/phone_binding',
                        name: 'personal_center_phone_binding',
                        meta: {
                            exp: '账号安全-绑定手机',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/phone_binding/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/mail_binding',
                        name: 'personal_center_mail_binding',
                        meta: {
                            exp: '账号安全-绑定邮箱',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/mail_binding/index.vue'),
                    },
                    {
                        path: '/personal_center/safe/QQ_binding',
                        name: 'personal_center_QQ_binding',
                        meta: {
                            exp: '账号安全-QQ绑定',
                            requireAuth: true
                        },
                        component: () => import('@/views/peronsal_center/safe/QQ_binding/index.vue'),
                    },
                ]
            },
            {
                path: '/personal_center/notify',
                name: 'personal_center_notify',
                meta: {
                    exp: '消息通知',
                    requireAuth: true
                },
                component: () => import('@/views/peronsal_center/notify/index.vue'),
            },
            {
                path: '/join',
                name: 'join',
                meta: {
                    exp: '入驻平台',
                    requireAuth: true
                },
                component: () => import("@/views/peronsal_center/join/index.vue")
            },
        ]
    },
    {
        path: '/upload_opus',
        name: 'upload_opus',
        meta: {
            exp: '上传作品',
            requireAuth: true
        },
        component: () => import("@/views/peronsal_center/upload_opus/index.vue")
    },
    {
        path: '/upload_final_design',
        name: 'upload_final_design',
        meta: {
            exp: '上传毕设',
            requireAuth: true
        },
        component: () => import("@/views/peronsal_center/upload_opus/final_design.vue")
    },
    {
        path: '/upload_prize',
        name: 'upload_prize',
        meta: {
            exp: '上传作品获奖情况',
            requireAuth: true
        },
        component: () => import("@/views/peronsal_center/upload_opus/upload_prize.vue")
    },
    {
        path: '/join_status',
        name: 'join_status',
        meta: {
            exp: '设计师认证审核中',
            requireAuth: true
        },
        component: () => import("@/views/peronsal_center/join/status/index.vue")
    }
]
export default routers
